<template>
  <modal title="Book Shipment" no width="40" :showModal="showModal" @close-modal="closeModal" :showTitle="false">
    <div class="px-8 flex flex-col gap-4 overflow-hidden">
      <div class="flex items-center justify-between">
        <b class="text-lg font-semibold">Book Shipment</b>
        <span @click="closeModal" class="cancel_btn">&#x2715;</span>
      </div>
      <div class="mt-3">
        <div class="flex items-center gap-3 mb-3 cursor-pointer" v-for="(value, index) in shippingTypes"
          :key="value.value + index" @click="shippingMethod = value.value">
          <span :class="[value.value === shippingMethod ? 'ball_active' : 'ball_inactive']"></span>
          <p>{{ value.name }}</p>
          <div class="tool_wrapper relative">

            <img class="cursor-pointer" src="../../../../views/3pl/BillingandCollection/icons/tool-tip.svg" alt="eye">
            <div class="tooltip-box">
              <p>{{ value.label }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-end gap-4">
        <button @click="closeModal">Cancel</button>
        <base-button :disabled="disableContinuation" text="Next" @click="submit" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      shippingMethod: "",
      shippingTypes: [
        {
          name: "Door to Door",
          value: "door-to-door",
          label: "Pick up from my address and deliver to receiver's address."
        },
        {
          name: "Door to Terminal",
          value: "door-to-terminal",
          label: "Pick up from my address and the Receiver will pick up from the terminal."
        },
        {
          name: "Terminal to Door",
          value: "terminal-to-door",
          label: "I want to drop off the package at the terminal and the Receiver will pick up from the terminal."
        },
        {
          name: "Terminal to Terminal",
          value: "terminal-to-terminal",
          label: "I want to drop off the package at the terminal and the Receiver will pick up from the terminal."
        }
      ]
    };
  },
  watch: {
    showModal() {
      // code here
    },
  },
  computed: {
    disableContinuation() {
      return this.shippingMethod == "";
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('setNewBookingShipmentMethod', this.shippingMethod);
      if (this.shippingMethod === "door-to-door" || (this.shippingMethod === "terminal-to-terminal" && this.$_isDevelopment)) {
        this.$store.dispatch('setSavedActiveTab', 1)
        this.$router.push({ name: "BookingFlowNew" });
        this.closeModal();
        return;
      }
       this.generateToast("This shipping method isn’t active yet, but it is coming soon","error" );
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>



<style scoped lang="scss">
.ball_inactive {
  @apply w-[25px] h-[25px] rounded-full bg-slate-200 relative inline-flex justify-center items-center;
}

.ball_active {
  @apply w-[25px] h-[25px] rounded-full bg-slate-100 relative inline-flex justify-center items-center;

  &::before {
    content: "";
    @apply relative w-[60%] h-[60%] rounded-[inherit] bg-primary-yellow
  }
}

.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}

.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}

.suspender {
  @apply shadow-lg w-full z-10;
  max-height: 200px;
  bottom: calc(100% + 10px);
  overflow-y: scroll;
  background-color: white;

  span {
    @apply block w-full p-2 cursor-pointer;
    border-bottom: 1px solid rgba(237, 242, 247);

    &:hover {
      @apply bg-gray-200
    }
  }
}

input:disabled {
  @apply cursor-not-allowed text-gray-400;
}

.tooltip-box {
  display: none;
  position: absolute;
  top: 0%;
  left: 100%;
  width: 250px;
  background-color: #10233e;
  color: #F0F4FE;
  padding: 16px;
  border-radius: 8px;
  z-index: 999;
  font-size: 13px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

.tooltip-box h4 {
  margin: 10px 0 5px;
  font-size: 14px;
  font-weight: bold;
}

.tooltip-box p {
  font-weight: 400;
  margin: 0 0 10px;
  font-size: 12px;
  line-height: 1.4;
}

.tool_wrapper:hover .tooltip-box {
  display: block;
}

.cancel_btn {
  @apply w-[20px] h-[20px] border-[1px] border-red-500 inline-flex justify-center items-center rounded-full text-red-500 text-[13px] cursor-pointer
}
</style>
